import { deepTrim, vueAppApiBaseAddress } from '@/utils/mixins'
import { getHeaders } from '@/utils/headers'
import { REDIRECT_TO_LOGOUT_HEADER } from '../constants'

export default class MobileLinkMiddleWare {
  constructor(store) {
    this.store = store
  }

  onRequest(config) {
    if (
      config.data != undefined &&
      (config.method == 'post' || config.method == 'put') &&
      config.headers['Content-Type'] != 'multipart/form-data'
    ) {
      var obj = JSON.parse(config.data)
      deepTrim(obj)
      config.data = JSON.stringify(obj)
    }
    // var header = getHeaders()
    // config.headers = header
    return config
  }
  onSync(promise) {
    return promise
  }
  onResponse(response) {
    return response
  }
  onResponseError(error) {
    //If this response is an error redirect from the authprovider, we should sign the user out
    if (error.response?.status === 401 && error.response?.headers?.[REDIRECT_TO_LOGOUT_HEADER]) {
      this.store.dispatch('clearAll')

      window.location.replace(vueAppApiBaseAddress() + `Auth/Auth0/SignOut`)
    }
    return Promise.reject(error)
  }
}
